var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({class:['nav-logo', ("nav-logo--" + _vm.variant), ("nav-logo--" + _vm.theme)],attrs:{"href":_vm.homepageUrl},on:{"click":_vm.trackLogoClick}},_vm.$listeners),[_c('IconOnLogo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }